export default __webpack_public_path__ + "static/media/Unshipped.8b5c309f.png";